export default {"src":"/_next/static/media/auth-background.23af6216.svg","height":1024,"width":1440,"blurWidth":0,"blurHeight":0};